import { apiAuth } from "../config/api";

export async function getDealerSettings() {
    return await apiAuth.fetch(`/api/dealer`, {
        method: 'GET',
    });
}

export async function getDealerDashboard() {
    return await apiAuth.fetch(`/api/dealer/dashboard`, {
        method: 'GET',
    });
}

export async function updateDealerSettings(payload) {
    return await apiAuth.fetch(`/api/dealer`, {
        method: 'PATCH',
        body: payload,
    });
}

export async function updateDealerNegotiationRules(negotiationRules) {
    return await apiAuth.fetch(`/api/dealer/negotiation-rules`, {
        method: 'PATCH',
        body: { negotiationRules },
    });
}

export async function updateDealerCRMSettings(crmEndpoint, crmApiKey) {
    return await apiAuth.fetch(`/api/dealer/crm-settings`, {
        method: 'PATCH',
        body: { crmEndpoint, crmApiKey },
    });
} 
export async function getDealerSchedule() {
    return await apiAuth.fetch(`/api/dealer-schedule`, {
        method: 'GET',
    });
}
export async function updateDealerSchedule(payload) {
    return await apiAuth.fetch(`/api/dealer-schedule`, {
        method: 'PATCH',
        body: payload,
    });
}